import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { DoughnutChart, DoughnutResultToChart } from './doughnut-chart';
import { Observable } from 'rxjs/Observable';

@Injectable()
export class DoughnutChartService {
  prepareChartOnEmptyData(): DoughnutChart[] {
    return [
      {
        count: 16,
        label: 'STATS.OPEN'
      },
      {
        count: 18,
        label: 'STATS.SCHEDULED'
      },
      {
        count: 45,
        label: 'STATS.AUTO_SCHEDULED'
      }
    ];
  }

  constructor(private translate: TranslateService) {}

  translateChartLabels(results: DoughnutChart[]): Observable<string[]> {
    return this.translate.get(results.map(el => el.label)).map(object => Object.values(object));
  }

  checkEmpty(results: DoughnutChart[]) {
    return !results.length || results.filter(el => el.count === 0).length === results.length;
  }

  prepareChart(results: DoughnutChart[]): DoughnutResultToChart {
    return {
      data: results.map(el => el.count)
    };
  }

  updateChartXLabels(labels, charts): void {
    // because chart.js not update labels
    if (charts && charts.last && charts.last.chart) {
      charts.last.chart.config.data.labels = labels;
    }
  }
}
